<template>
    <div id="about">
        <normal-header :data="header" />
        <div id = "about-content">
            <stepper />
            <AboutBox title="about.aboutEOtitle" content="about.aboutEO"></AboutBox>
            <div class = "challenges">
                <h2 id="main">Main Challenge</h2>
                <RowSection :challenge = "main"></RowSection>
                <h2 id="side">Side Challenges</h2>
                <RowSection v-for="(side, index) in sides" :key="index"  :challenge = "side" :isReversed="isEven(index)"></RowSection>        
                <h2>Stand & Fun Day</h2>
                <StandAndFun> </StandAndFun>
            </div>
            <team-lineup />
            <h1 class = "titluIstoric"> EESTEC Olympics Roadtrip </h1>
            <History/>
            <Eestec/>
        </div>
    </div>
</template>

<script>
import StandAndFun from "@/components/about-components/StandAndFun"
import RowSection from "@/components/about-components/RowSection"
import AboutBox from "@/components/about-components/AboutBox";
import History from "@/components/about-components/History";
import NormalHeader from '@/components/global-components/NormalHeader'
import TeamLineup from '@/components/about-components/TeamLineup'
import Eestec from '@/components/heroes/Eestec.vue'
import Stepper from '@/components/widgets/Stepper'

import {sides, main, side} from "@/assets/resources/challenges"

export default {
    components: {
        RowSection,
        History,
        AboutBox,
        NormalHeader,
        TeamLineup,
        Eestec,
        StandAndFun,
        Stepper
    },
     data () {
        return {
            sides,
            side,
            main,
            header: {
                transparent: false
            }
        }
    },
    methods: {
        isEven(index) {
            return index % 2 === 0;
        }
    }    
}
</script>

<style lang="scss" scoped>
.challenges {
    @extend %eestec-page;
}

.titluIstoric {
    margin-top: 3%;
    font-size : 40px;
}
</style>